// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_m0dMw","container":"container_bsmne","btn-debug":"btn-debug_VQDvh"};